import Route from '@ember/routing/route';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import NewsletterAccountModel from 'donor-elf-web/models/newsletter-account';
import { type NewsletterRouteModel } from '../newsletter';
import FundModel from 'donor-elf-web/models/fund';
import RouterService from '@ember/routing/router-service';
import FundsService from 'donor-elf-web/services/funds-service';

export interface NewsletterConnectedToOtherFundRouteModel {
  newsletterAccount?: NewsletterAccountModel;
  newsletterFund: FundModel;
}

export default class NewsletterConnectedtoOtherFundRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare store: Store;
  @service declare router: RouterService;

  beforeModel() {
    let parentModel = this.modelFor(
      'funds.fund.more.newsletter',
    ) as NewsletterRouteModel;
    if (
      parentModel.newsletterAccount &&
      parentModel.newsletterAccount.fundId ===
        this.fundsService.selectedFund?.id
    ) {
      this.router.transitionTo('funds.fund.more.newsletter.connected');
    }
  }

  async model(): Promise<NewsletterConnectedToOtherFundRouteModel> {
    let parentModel = this.modelFor(
      'funds.fund.more.newsletter',
    ) as NewsletterRouteModel;
    let newsletterFund = await this.store.findRecord(
      'fund',
      parentModel.newsletterAccount!.fundId!,
    );
    return Object.assign(parentModel, { newsletterFund });
  }
}
